module.exports = __webpack_public_path__ + "img/fabric_1.aa8cb4d9.jpg";